import {createAction} from "@reduxjs/toolkit";

export const setEvent = createAction('SET_EVENT');